import _ from "lodash";
import shortid from "shortid";
import { getAppConfig } from "config/client.config";

export const CREATE_DECK = "CREATE_DECK";
export const CLEAR_DECK = "CLEAR_DECK";
export const UPDATE_DECK = "UPDATE_DECK";
export const LOAD_DECK = "LOAD_DECK";
export const FETCH_IMAGES = "FETCH_IMAGES";
export const EDITOR_RENAME_DECK = "EDITOR_RENAME_DECK";
export const ADD_SLIDE = "ADD_SLIDE";
export const DUPLICATE_SLIDE = "DUPLICATE_SLIDE";
export const RESET_SLIDE = "RESET_SLIDE";
export const DELETE_SLIDE = "DELETE_SLIDE";
export const CHANGE_TEMPLATE = "CHANGE_TEMPLATE";
export const CHANGE_NAV = "CHANGE_NAV";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const CHANGE_MINTIME = "CHANGE_MINTIME";

const _createDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CREATE_DECK, data, err, status };
};
const _clearDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CLEAR_DECK, data, err, status };
};
const _updateDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: UPDATE_DECK, data, err, status };
};
const _renameDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: EDITOR_RENAME_DECK, data, err, status };
};
const _loadDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: LOAD_DECK, data, err, status };
};
const _fetchImages = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return {
        type: FETCH_IMAGES,
        data,
        err,
        status,
    };
};
const _addSlide = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: ADD_SLIDE, data, err, status };
};
const _duplicateSlide = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: DUPLICATE_SLIDE, data, err, status };
};
const _resetSlide = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: RESET_SLIDE, data, err, status };
};
const _deleteSlide = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: DELETE_SLIDE, data, err, status };
};
const _changeTemplate = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CHANGE_TEMPLATE, data, err, status };
};
const _changeNav = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CHANGE_NAV, data, err, status };
};
const _changeLanguage = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CHANGE_LANGUAGE, data, err, status };
};
const _changeMinTime = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: CHANGE_MINTIME, data, err, status };
};

const createDeck = /* istanbul ignore next - redux passthrough function */ (
    name,
    readerType,
    contentHash
) => {
    return (dispatch) => {
        let adjContentHash = contentHash;
        _.each(adjContentHash, (row, idx) => {
            row.id = shortid.generate();
        });
        return Promise.resolve(
            dispatch(
                _createDeck(
                    "creating",
                    {
                        name: name,
                        readerType: readerType,
                        contentHash: adjContentHash,
                        shortid: {
                            deckId: shortid.generate(),
                            firstSlideId: shortid.generate(),
                        },
                    },
                    null
                )
            )
        );
    };
};

const clearDeck = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch) => {
        return Promise.resolve(dispatch(_clearDeck("clearing", null, null)));
    };
};
const updateDeck = /* istanbul ignore next - redux passthrough function */ (
    data
) => {
    return (dispatch) => {
        return Promise.resolve(dispatch(_updateDeck("updating", data, null)));
    };
};

const loadDeck = /* istanbul ignore next - redux passthrough function */ (
    id
) => {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            getAppConfig().endpoints.contentPaths["getDeckPath"].replace(
                ":id",
                id
            )
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(
                        dispatch(_loadDeck("opening", data, null))
                    );
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const addImagesToLibrary = (contentHash) => {
    let result = [];
    if (contentHash instanceof Array) {
        for (var i = 0; i < contentHash.length; i++) {
            result.push(addImagesToLibrary(contentHash[i]));
        }
    } else {
        let sectionResult = [];
        for (var prop in contentHash) {
            if (prop === "presenter") {
                sectionResult.push(contentHash.presenter);
            }
            if (prop === "image") {
                sectionResult.push(contentHash.image);
            }
            if (prop === "background") {
                sectionResult.push(contentHash.background);
            }
            if (
                contentHash[prop] instanceof Object ||
                contentHash[prop] instanceof Array
            )
                sectionResult.push(addImagesToLibrary(contentHash[prop]));
        }
        if (sectionResult.length > 0) return sectionResult;
    }
    return _.flatten(result);
};

const fetchImageLibrary = () => {
    return (dispatch, getState, Request) => {
        let imageList = _.flatten(
            _.uniq(_.flatten(addImagesToLibrary(getState().deck.content)))
        );
        _.each(imageList, (srcImg) => {
            let img = Array.isArray(srcImg)
                ? srcImg[0]
                : typeof srcImg === "object"
                ? srcImg["image"]
                : srcImg;
            let url =
                getAppConfig().apiUrls.assetUrl +
                getAppConfig().apiUrls.libraryUrl +
                img;
            if (
                img !== undefined &&
                img.indexOf("data:") === -1 &&
                img.indexOf("assets/images/") === -1 &&
                img.indexOf(".jpg") === -1 &&
                img.indexOf(".JPG") === -1 &&
                img.indexOf(".jpeg") === -1 &&
                img.indexOf(".JPEG") === -1 &&
                img.indexOf(".gif") === -1 &&
                img.indexOf(".GIF") === -1 &&
                img.indexOf(".png") === -1 &&
                img.indexOf(".PNG") === -1 &&
                img.indexOf(".svg") === -1
            ) {
                Request.fetch(url)
                    .then((resp) => {
                        return resp.json();
                    })
                    .then((data) => {
                        return dispatch(
                            _fetchImages(
                                "success",
                                {
                                    id: srcImg,
                                    image: data,
                                },
                                null
                            )
                        );
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        });
        return Promise.resolve(0);
    };
};

const renameDeck = /* istanbul ignore next - redux passthrough function */ (
    name
) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch(_renameDeck("updating", { name: name }, null))
        );
    };
};

const addSlide = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _addSlide(
                    "Adding Slide",
                    {
                        slideId: shortid.generate(),
                    },
                    null
                )
            )
        );
    };
};

const duplicateSlide = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _duplicateSlide(
                    "Duplicating Slide",
                    {
                        slideId: shortid.generate(),
                    },
                    null
                )
            )
        );
    };
};

const resetSlide = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(_resetSlide("Resetting Slide", {}, null))
        );
    };
};

const deleteSlide = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(_deleteSlide("Deleting Slide", {}, null))
        );
    };
};

const changeTemplate = /* istanbul ignore next - redux passthrough function */ (
    newTemplate
) => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _changeTemplate(
                    "Changing Template",
                    { newTemplate: newTemplate },
                    null
                )
            )
        );
    };
};

const changeSlideNav = /* istanbul ignore next - redux passthrough function */ (
    navObj
) => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(_changeNav("Changing Navigation", { nav: navObj }, null))
        );
    };
};

const changeLanguage = /* istanbul ignore next - redux passthrough function */ (
    langCode
) => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _changeLanguage(
                    "Changing Language",
                    { language: langCode },
                    null
                )
            )
        );
    };
};

const changeMinTime = /* istanbul ignore next - redux passthrough function */ (
    minTime
) => {
    return (dispatch, getState) => {
        return Promise.resolve(
            dispatch(
                _changeMinTime("Changing Min Time", { minTime: minTime }, null)
            )
        );
    };
};

const uploadDeck = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState, Request) => {
        let currentDeck = JSON.parse(JSON.stringify(getState().deck));
        let uploadedDeck = JSON.stringify(currentDeck).replace(
            '"id"',
            '"shortId"'
        );
        return Request.fetch(getAppConfig().endpoints.uploadQDFPath, {
            body: uploadedDeck,
            method: "POST",
        })
            .then(() => {
                console.log("Success");
            })
            .catch(() => {
                console.log("Failure");
            });
    };
};

class DeckEditorAction {
    static createDeck = createDeck;
    static clearDeck = clearDeck;
    static updateDeck = updateDeck;
    static loadDeck = loadDeck;
    static fetchImageLibrary = fetchImageLibrary;
    static renameDeck = renameDeck;
    static addSlide = addSlide;
    static duplicateSlide = duplicateSlide;
    static resetSlide = resetSlide;
    static deleteSlide = deleteSlide;
    static changeTemplate = changeTemplate;
    static changeLanguage = changeLanguage;
    static changeSlideNav = changeSlideNav;
    static changeMinTime = changeMinTime;
    static uploadDeck = uploadDeck;
}

export default DeckEditorAction;
